import { UserArticleQuizStage } from '../../Types/UserArticle';
import { SessionArticleEvent } from '../ISessionEvent';

export type ArticleActivityStage = UserArticleQuizStage | 'chapter_builder';

export class ArticleActivityEvent extends SessionArticleEvent {
  constructor(
    articleId: string,
    timeSpent: number,
    wordsRead: number,
    stage: ArticleActivityStage | null,
  ) {
    super('article-activity', articleId, {
      timeSpent,
      wordsRead,
      stage,
    });
  }
}
